import type { FC } from 'react';
import React from 'react';
import { alpha, Chip } from '@mui/material';
import { Iconify } from '../Iconify';
import type { FilterDefinition } from './declarations/type';
import { colouredPillSx } from './colouredPillSx';

// A boolean filter has nothing to edit, so its pill toggles on click.
export const TogglePill: FC<{
  filter: Extract<FilterDefinition<unknown>, { type: 'boolean' }>;
}> = ({ filter }) => {
  const { color = 'primary' } = filter;
  return (
    <Chip
      label={filter.label}
      variant="outlined"
      color={filter.value && color === 'primary' ? 'primary' : 'default'}
      onClick={() => filter.onChange(!filter.value)}
      aria-pressed={filter.value}
      icon={
        <Iconify
          icon={filter.value ? 'eva:checkmark-fill' : 'eva:plus-fill'}
          width={18}
        />
      }
      sx={
        color === 'primary'
          ? (theme) =>
              filter.value
                ? { bgcolor: alpha(theme.palette.primary.main, 0.08) }
                : { bgcolor: 'background.paper' }
          : colouredPillSx(color, filter.value)
      }
    />
  );
};
